<ion-card
  mode="ios"
  color="transparent"
  class="card-promocion"
  type="button"
  button
  (click)="openModalZoom(promocion.imagen_url)"
>
  <ng-container *ngIf="promocion.Vigencia > 1">
    <ion-button
      class="mpe-button-icon-circle ion-no-padding validity-circle"
      size="default"
      mode="ios"
      shape="round"
      color="danger"
    >
      <ion-label color="white" mode="md" class="validity-number">
        {{ promocion.Vigencia }}
        <p class="validity-text">
          <ion-text color="white" mode="md">
            {{ "Labels.days" | translate }}
          </ion-text>
        </p>
      </ion-label>
    </ion-button>
  </ng-container>

  <ng-container *ngIf="promocion.Vigencia < 2">
    <ion-button
      class="mpe-button-icon-circle validity-vence"
      size="default"
      mode="ios"
      shape="round"
      color="danger"
    >
      <ion-label color="white" mode="md" class="content-expires">
        <ion-text
          mode="md"
          class="validity-hoy"
          [innerHtml]="
            'Labels.promotion-expires-today' | translate | htmlSeguro
          "
        >
        </ion-text>
        <p class="mpe-font-weight-600 validity-aprovecha">
          {{ "Labels.advantage" | translate }}
        </p>
      </ion-label>
    </ion-button>
  </ng-container>

  <ion-button
    class="mpe-button-icon-circle ion-no-padding expand-img"
    size="default"
    mode="ios"
    shape="round"
    color="white"
  >
    <ion-icon slot="icon-only" name="expand" color="dark"></ion-icon>
  </ion-button>

  <ion-thumbnail class="img-promo">
    <ion-img [src]="promocion.imagen_url" cache="true"></ion-img>
  </ion-thumbnail>
</ion-card>
